import http from '@/biz/http.mjs'

export default {
    readList: args => http.get('/amdo/listAmDoDe', args),
}
